export const IMAGES_PER_LISTING = 8;
